/**
 * External dependencies
 */
import React from "react"

/**
 * Internal dependencies
 */
import "./styles/_index.scss"
import { Dropdown } from "react-bootstrap"

const PropertyPaging = () => {
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      className="toggle"
      role="presentation"
      ref={ref}
      onClick={e => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
    </div>
  ))

  return (
    <div className="property-paging" data-aos="fade-up">
      <div className="shell">
        <div className="property-paging__inner">
          <div className="property-paging__previous">
            <button className="btn">
              <i className="icon-arrow-left"></i>
              <span>Previous</span>
            </button>
          </div>

          <div className="property-paging__page">
            <span>Page:</span>
            <Dropdown>
              <Dropdown.Toggle as={CustomToggle}>1</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#">1</Dropdown.Item>
                <Dropdown.Item href="#">2</Dropdown.Item>
                <Dropdown.Item href="#">3</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="property-paging__next">
            <button className="btn">
              <span>Next</span>
              <i className="icon-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyPaging
